export default __webpack_public_path__ + "static/media/sepid-sabt.9fdcd34f.jpg";